/* Chewy-style mobile drill-down menu. Reads the clean nested <ul> tree
   emitted by snippets/llm-mobile-nav.liquid and builds a stack of
   sliding panels: tapping any item with children slides in a fresh
   panel of ONLY those children (with a parent-named back link, a
   heading, and a "Shop all" link), identical at every level. Fully
   independent of the stock accordion nav engine (main.js) - see the
   snippet's comment for why. */
(function () {
  var CHEVRON_RIGHT = '<svg viewBox="0 0 16 16" class="llm-mnav__chevron" aria-hidden="true" focusable="false"><path d="M6 3l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON_LEFT = '<svg viewBox="0 0 16 16" class="llm-mnav__back-icon" aria-hidden="true" focusable="false"><path d="M10 3L5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(root) {
    var dataRoot = root.querySelector('.llm-mnav__data');
    var viewport = root.querySelector('.llm-mnav__viewport');
    if (!dataRoot || !viewport) return;

    // Stack of { panel, li } - the currently-open drill path. Index 0 is
    // the root panel (always present); each deeper entry is a child
    // panel sliding over the previous.
    var stack = [];

    // Direct <li> children of a <ul> (the items at one level).
    function itemsOf(ul) {
      return Array.prototype.filter.call(ul.children, function (el) {
        return el.tagName === 'LI';
      });
    }

    // The child <ul> of an <li>, if it has one (i.e. this item drills).
    function childUlOf(li) {
      return Array.prototype.find.call(li.children, function (el) {
        return el.tagName === 'UL';
      }) || null;
    }

    function buildPanel(opts) {
      // opts: { items, parentTitle, headingTitle, headingUrl, depth }
      var panel = document.createElement('div');
      panel.className = 'llm-mnav__panel';

      if (opts.depth > 0) {
        // One row: the category name on the left, a "‹ Back" link on the right
        // (owner: "Adult Diapers  ‹ Back"), instead of two stacked rows.
        var head = document.createElement('div');
        head.className = 'llm-mnav__head';
        var h = document.createElement('span');
        h.className = 'llm-mnav__heading';
        h.textContent = opts.headingTitle;
        var back = document.createElement('button');
        back.type = 'button';
        back.className = 'llm-mnav__back';
        back.innerHTML = CHEVRON_LEFT + '<span>Back</span>';
        back.addEventListener('click', pop);
        head.appendChild(h);
        head.appendChild(back);
        panel.appendChild(head);
      }

      var list = document.createElement('ul');
      list.className = 'llm-mnav__list';

      // "Shop all [category]" as the prominent FIRST list item (moved here from a
      // small link in the head — shoppers were missing it off to the right). Only for
      // shoppable collections: gate on a real /collections/ heading URL so it appears
      // for Incontinence / Adult Diapers / etc. but never for Customer Service and the
      // like (whose urls are /pages/...).
      if (opts.depth > 0 && opts.headingUrl && opts.headingUrl.indexOf('/collections/') !== -1) {
        var allRow = document.createElement('li');
        allRow.className = 'llm-mnav__item llm-mnav__item--shop-all';
        var allLink = document.createElement('a');
        allLink.className = 'llm-mnav__link llm-mnav__link--shop-all';
        allLink.href = opts.headingUrl;
        allLink.innerHTML =
          '<span class="llm-mnav__label"><span>Shop all ' + escapeHtml(opts.headingTitle) + '</span></span>';
        allRow.appendChild(allLink);
        list.appendChild(allRow);
      }

      opts.items.forEach(function (li) {
        var title = li.getAttribute('data-title') || '';
        var url = li.getAttribute('data-url') || '#';
        var image = li.getAttribute('data-image') || '';
        var childUl = childUlOf(li);
        var isCurrent = li.getAttribute('data-current') === 'true';
        var row = document.createElement('li');
        row.className = 'llm-mnav__item';

        // Optional collection thumbnail (tier-1 collections) + title,
        // grouped so they stay left while the chevron pushes right.
        var thumb = image
          ? '<img class="llm-mnav__thumb" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" aria-hidden="true" loading="lazy" width="32" height="32">'
          : '';
        var label = '<span class="llm-mnav__label">' + thumb + '<span>' + escapeHtml(title) + '</span></span>';

        if (childUl) {
          // Drillable - a button that slides in this item's children.
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'llm-mnav__link llm-mnav__link--parent';
          // Owner: the top-level "Shop" entry gets a highlighted background
          // (like the desktop Shop pill). Tagged here so only the root Shop
          // row is styled, not every drillable parent (e.g. Customer
          // Service also has children).
          if (opts.depth === 0 && title.trim().toLowerCase() === 'shop') {
            btn.className += ' llm-mnav__link--shop';
          }
          // Baymard #7: highlight the category you're currently viewing (a current
          // category with sub-categories renders as a drillable button, e.g. Adult
          // Diapers, so it must be flagged here too — not just leaf links).
          if (isCurrent) {
            btn.className += ' llm-mnav__link--current';
            btn.setAttribute('aria-current', 'page');
          }
          btn.innerHTML = label + CHEVRON_RIGHT;
          btn.addEventListener('click', function () {
            push(li, title, url);
          });
          row.appendChild(btn);
        } else {
          // Leaf - a plain link.
          var a = document.createElement('a');
          a.className = 'llm-mnav__link';
          if (isCurrent) {
            a.className += ' llm-mnav__link--current';
            a.setAttribute('aria-current', 'page');
          }
          a.href = url;
          a.innerHTML = label;
          row.appendChild(a);
        }
        list.appendChild(row);
      });

      panel.appendChild(list);
      return panel;
    }

    function push(li, title, url) {
      var childUl = childUlOf(li);
      if (!childUl) return;
      var panel = buildPanel({
        items: itemsOf(childUl),
        parentTitle: currentTitle(),
        headingTitle: title,
        headingUrl: url,
        depth: stack.length
      });
      viewport.appendChild(panel);

      // Park the current panel to the left, slide the new one in.
      var current = stack[stack.length - 1].panel;
      // Force reflow so the initial (off-screen right) transform is
      // registered before we animate to on-screen.
      panel.getBoundingClientRect();
      current.classList.remove('is-active');
      current.classList.add('is-parked');
      panel.classList.add('is-active');

      stack.push({ panel: panel, title: title });
    }

    function pop() {
      if (stack.length < 2) return;
      var leaving = stack.pop();
      var current = stack[stack.length - 1].panel;

      leaving.panel.classList.remove('is-active'); // slides back out to the right
      current.classList.remove('is-parked'); // slides back in from the left
      current.classList.add('is-active');

      var removed = false;
      function cleanup() {
        if (removed) return;
        removed = true;
        if (leaving.panel.parentNode) leaving.panel.parentNode.removeChild(leaving.panel);
      }
      leaving.panel.addEventListener('transitionend', cleanup, { once: true });
      // Fallback in case transitionend doesn't fire (e.g. reduced motion).
      window.setTimeout(cleanup, 400);
    }

    function currentTitle() {
      return stack.length ? stack[stack.length - 1].title : '';
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // Baymard #7 (orient the shopper): open the menu already drilled to the
    // category they're currently viewing. Finds the deepest data-current item
    // (set by Liquid from Shopify's link.current — i.e. the nav link whose URL
    // matches this page) and drills down to its PARENT panel, so that item shows
    // highlighted among its siblings. Instant (no slide) so the menu simply
    // appears pre-drilled rather than animating a cascade on every open.
    function drillToCurrent() {
      var currentLi = dataRoot.querySelector('li[data-current="true"]');
      if (!currentLi) return; // e.g. product/home pages — no current category
      // Collect ancestor <li>s from the root down to the current item's parent.
      var chain = [];
      var node = currentLi.parentElement; // the <ul> holding currentLi
      while (node && node !== dataRoot) {
        if (node.tagName === 'LI') chain.unshift(node);
        node = node.parentElement;
      }
      if (!chain.length) return; // current item is already at the root level
      viewport.classList.add('llm-mnav--no-anim');
      chain.forEach(function (li) {
        push(li, li.getAttribute('data-title') || '', li.getAttribute('data-url') || '#');
      });
      viewport.getBoundingClientRect(); // settle the un-animated transforms
      requestAnimationFrame(function () {
        viewport.classList.remove('llm-mnav--no-anim');
      });
    }

    // Reset whenever the whole drawer is closed, then re-drill to the current
    // category so re-opening the hamburger always lands on where you are (not
    // wherever you last browsed to).
    function resetToRoot() {
      while (stack.length > 1) {
        var leaving = stack.pop();
        if (leaving.panel.parentNode) leaving.panel.parentNode.removeChild(leaving.panel);
      }
      if (stack[0]) {
        stack[0].panel.classList.remove('is-parked');
        stack[0].panel.classList.add('is-active');
      }
      drillToCurrent();
    }

    // Build the root panel (top-level items: Shop, main menu, quicklinks).
    var rootPanel = buildPanel({ items: itemsOf(dataRoot), depth: 0 });
    rootPanel.classList.add('is-active');
    viewport.appendChild(rootPanel);
    // Root title is used as the back-link label on the FIRST drilled
    // panel (e.g. "‹ Main menu" when you drill into Shop) - Chewy's own
    // wording for the top level.
    stack.push({ panel: rootPanel, title: 'Main menu' });

    // Open pre-drilled to the current category (if this page maps to one).
    drillToCurrent();

    root.removeAttribute('hidden');
    // Gate the hiding of the stock mobile nav on this class, so if this
    // script ever fails to run, the stock nav stays as a fallback
    // instead of leaving mobile with no menu at all (see llm-header.css).
    document.documentElement.classList.add('llm-mnav-active');

    // The menu now covers the full screen (over the header), so the stock
    // hamburger ✕ is hidden behind it — wire the in-menu close ✕ to trigger it.
    // Both the ✕ (left) and the "Close" text link (right) close the menu — they
    // carry .js-mnav-close and click the stock hamburger toggle (which the
    // full-screen menu covers).
    root.querySelectorAll('.js-mnav-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var toggle = document.querySelector('.main-menu__toggle');
        if (toggle) toggle.click();
      });
    });

    // Reset to root when the drawer closes. The stock main-menu toggle
    // removes .is-open from .main-menu__content on close; watch for that.
    var content = root.closest('.main-menu__content');

    // Backdrop dimming the sliver of page beside the open menu (owner). Inserted as a
    // SIBLING of the menu content so it shares the same stacking context and sits just
    // under it; tapping it closes the menu (standard drawer behaviour).
    var backdrop = null;
    if (content && content.parentNode) {
      backdrop = document.createElement('div');
      backdrop.className = 'llm-mnav__backdrop';
      content.parentNode.insertBefore(backdrop, content);
      backdrop.addEventListener('click', function () {
        var toggle = document.querySelector('.main-menu__toggle');
        if (toggle) toggle.click();
      });
    }

    if (content && 'MutationObserver' in window) {
      var obs = new MutationObserver(function () {
        var open = content.classList.contains('is-open');
        if (backdrop) backdrop.classList.toggle('is-visible', open);
        if (!open) resetToRoot();
      });
      obs.observe(content, { attributes: true, attributeFilter: ['class'] });
    }
  }

  document.querySelectorAll('.llm-mobile-nav').forEach(setup);

  // Mobile full-screen search: the "Cancel" link closes the predictive-search overlay
  // (owner, Carewell-style). Delegated so it works regardless of when search renders.
  document.addEventListener('click', function (e) {
    var cancel = e.target.closest('.js-search-cancel');
    if (!cancel) return;
    e.preventDefault();
    var ps = cancel.closest('predictive-search');
    if (!ps) return;
    var input = ps.querySelector('.search__input');
    if (input) input.value = '';
    if (typeof ps.close === 'function') {
      ps.close();
    } else {
      var ov = ps.querySelector('.js-search-overlay');
      if (ov) ov.click();
    }
    if (input) input.blur();
  });

  // Position the mobile Autoship tooltip (fixed) right under its trigger, clamped to the
  // viewport so it never runs off a right-column card's edge. Fixed lets it escape the card's
  // click-overlay so the ✕ Close is tappable. Desktop keeps the CSS hover dropdown.
  function positionAutoshipTip(info) {
    /* Dead on purpose since 2026-09-06: the Autoship copy now opens as a bottom sheet on phones
       (llm-info-sheet.js), and llm-info-sheet.css sets display:none on .llm-card-autoship__tip below
       750px. This function only ever ran on mobile, so there is nothing left for it to place.
       Kept — rather than deleted — because the desktop CSS hover dropdown still uses the same markup,
       and a future change that re-enables the tip on a narrow desktop window would want this back. */
    return;
    /* eslint-disable no-unreachable */
    if (window.innerWidth > 768.98) return;
    var cont = info.closest('.llm-card-autoship');
    var tip = cont && cont.querySelector('.llm-card-autoship__tip');
    if (!tip) return;
    var r = info.getBoundingClientRect();
    var tw = tip.offsetWidth || 300;
    var left = Math.max(8, Math.min(Math.round(r.left), window.innerWidth - tw - 8));
    tip.style.left = left + 'px';

    /* Vertical clamp, matching llm-fsa-tooltip.js. This was an unconditional
       `top: r.bottom + 8`, which for a card low in the viewport dropped the tooltip onto the
       sticky Add-to-cart bar — the tip is z-index 2147483000, so it wins over the bar's 5 and
       placement is the only thing that can keep it clear (same defect the FSA card tooltip had,
       owner 2026-09-06). Floor is the sticky bar's top edge, but only while that bar is really
       showing: it is visibility:hidden + translated off until the real Add-to-cart scrolls away. */
    var floor = window.innerHeight;
    var bar = document.querySelector('.sticky-atc-panel');
    if (bar) {
      var bs = getComputedStyle(bar);
      if (bs.display !== 'none' && bs.visibility !== 'hidden') {
        var brect = bar.getBoundingClientRect();
        if (brect.height > 0 && brect.top < floor) floor = brect.top;
      }
    }
    var th = tip.offsetHeight;
    var below = r.bottom + 8;
    var top;
    if (below + th <= floor - 8) top = below;              // fits underneath — preferred
    else if (r.top - 8 - th >= 8) top = r.top - 8 - th;    // no room: flip above the trigger
    else top = Math.max(8, floor - 8 - th);                // neither: sit just clear of the bar
    tip.style.top = Math.round(top) + 'px';
  }
  // A scroll would detach the fixed tooltip from its trigger — close it instead.
  window.addEventListener('scroll', function () {
    document.querySelectorAll('.llm-card-autoship__info.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
  }, { passive: true });

  // Product-card "Autoship" benefits tooltip: tap/click toggles it — so it works on touch,
  // and blocks the card's stretched-link overlay from opening the product. (Desktop also
  // gets it on hover via CSS.) A click anywhere else closes any open one.
  document.addEventListener('click', function (e) {
    // Explicit "✕ Close" on the tooltip.
    var closeBtn = e.target.closest('.llm-card-autoship__tip-close');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      // The tooltip is a sibling of the trigger now, so reach the trigger via the container.
      var cont = closeBtn.closest('.llm-card-autoship');
      var inf = cont && cont.querySelector('.llm-card-autoship__info');
      if (inf) inf.classList.remove('is-open');
      return;
    }
    // Taps inside the open tooltip body (not the close) keep it open so it's readable.
    if (e.target.closest('.llm-card-autoship__tip')) {
      e.stopPropagation();
      return;
    }
    // The trigger (icon + "Autoship" word) toggles.
    var info = e.target.closest('.llm-card-autoship__info');
    if (info) {
      e.preventDefault();
      e.stopPropagation();
      var willOpen = !info.classList.contains('is-open');
      document.querySelectorAll('.llm-card-autoship__info.is-open').forEach(function (el) {
        if (el !== info) el.classList.remove('is-open');
      });
      info.classList.toggle('is-open', willOpen);
      if (willOpen) positionAutoshipTip(info);
      return;
    }
    // A tap anywhere else closes any open one.
    document.querySelectorAll('.llm-card-autoship__info.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
  });

  /* Hover tooltips on touch: they open on tap (:focus) and the "✕ close" dismisses them.
     Blurring alone won't beat :focus-within (the ✕ lives INSIDE the focusable host) or a sticky
     :hover, so we also flag .is-dismissed — CSS force-hides the tip while focus/hover linger; the
     next tap on the host clears the flag so the tooltip can reopen.

     ⚠️ GENERIC ON PURPOSE. This was bound to `.llm-fsa-badge` alone until 2026-09-21, when the
     "Low return rate" / repeat-purchase claims gained the same tooltip. Copying the handler for
     them would have produced two implementations of one interaction, and the copy would drift the
     first time either was touched. Both now carry `llm-tip-host` + `llm-tip-close` alongside their
     own BEM names, so ONE handler drives both — add those two classes to any future tooltip
     instead of extending the selector list here. */
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.llm-tip-close, .llm-fsa-badge__tip-close');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var host = closeBtn.closest('.llm-tip-host, .llm-fsa-badge');
      if (host) {
        host.classList.add('is-dismissed');
        host.blur();
      }
      closeBtn.blur();
      return;
    }
    // A tap on the host itself clears the dismissed flag so it can open again.
    var openHost = e.target.closest('.llm-tip-host, .llm-fsa-badge--interactive');
    if (openHost) openHost.classList.remove('is-dismissed');
  });
})();
